<template>
  <div>
    <form-field-select
        label="Campaign"
        v-model="form.campaign_id"
        :validation-errors="validationErrors.campaign_id"
    >
      <option :value="null">No Campaign</option>
      <option v-for="campaign in $store.getters.activeCampaigns" :value="campaign.id">{{campaign.label}}</option>
    </form-field-select>

    <form-field-select
      label="Motivation"
      v-model="form.motivation"
      :validation-errors="validationErrors.motivation"
    >
      <option v-for="option in ENUMS.MotivationEnum" :value="option.value">{{option.label}}</option>
    </form-field-select>

    <form-field-select
        label="Exit Strategy"
        v-model="form.exit_strategy"
        :validation-errors="validationErrors.exit_strategy"
    >
      <option v-for="option in ENUMS.ExitStrategyEnum" :value="option.value">{{option.label}}</option>
    </form-field-select>

    <form-field-select
        label="Temperature"
        v-model="form.temperature"
        :validation-errors="validationErrors.temperature"
    >
      <option v-for="option in ENUMS.TemperatureEnum" :value="option.value">{{option.label}}</option>
    </form-field-select>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";

  export default {
    name: "LeadDetailsForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          campaign_id: '',
          exit_strategy: '',
          temperature: '',
          motivation: '',
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    methods: {
      update() {
        return this.$api.records.updateLeadDetails(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Lead details was updated',
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
